<template>
	<div>
		<van-nav-bar class="userNavBar" @click-left="onClickLeft" title="我的消息" left-arrow>
			<template #left>
				<van-icon name="../../../static/images/mobile/back.png" size="18" />
			</template>
		</van-nav-bar>
		<!-- <van-cell-group v-for="item in messageLists" :key="item.id" inset>
			<van-cell icon="../../../static/images/mobile/remind.png" :title="item.sourceTypeName" :value="item.pubTimeString" :label="item.content" />
		</van-cell-group> -->
		<div class="mobileNews" style="margin-top: 0.426667rem">
			<van-cell class="mobileRemind" @click="moreNews" icon="../../../static/images/mobile/remind.png" title="提醒" value="2021/11/11" label="计算机班级课程明天开课啦!" ></van-cell>
			<van-cell icon="../../../static/images/mobile/notice.png" title="通知" value="2021/11/11" label="计算机班级课程明天开课啦!" />
			<van-cell class="mobileTrain" icon="../../../static/images/mobile/train.png" title="培训" value="2021/11/11" label="计算机班级课程明天开课啦!" />
		</div>
		<van-tabbar v-model="active">
			<van-tabbar-item to="/mobileHome">
				<span>首页</span>
				<template #icon="props">
					<img :src="props.active ? index.active : index.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileStudy">
				<span>班级</span>
				<template #icon="props">
					<img :src="props.active ? classes.active : classes.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileMy">
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ? my.active : my.inactive" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
export default {
	data() {
		return {
			active: 2,
			index: {
				active: "../../../static/images/mobile/onIndex.png",
				inactive: "../../../static/images/mobile/index.png",
			},
			classes: {
				active: "../../../static/images/mobile/onClass.png",
				inactive: "../../../static/images/mobile/class.png",
			},
			my: {
				active: "../../../static/images/mobile/onMy.png",
				inactive: "../../../static/images/mobile/my.png",
			}, //table栏
			pageNumber: 1,
			pageSize: 10,
			sourceType: "035001",
			messageLists: [],
			pubTimeString: "",
		};
	},
	methods: {
		onClickLeft() {
			this.$router.go(-1);
		},
		messageList() {
			let pageSize = this.pageSize;
			let pageNumber = this.pageNumber;
			let sourceType = this.sourceType;
			let params = {};
			params.pageSize = pageSize;
			params.pageNumber = pageNumber;
			params.sourceType = sourceType;
			this.$axiosPackag.getMessageByAxios("GET", "/foreground/systemMessage/getList", params, null, null, (resD) => {
				this.messageLists = resD.rows;
			});
		},
		moreNews() {
			this.$router.push({ path: "/mobileNewsMore" });
		},
	},
	created() {
		this.messageList();
	},
	beforeCreate() {
		document.querySelector("body").setAttribute("style", "background:#eee");
	}, //
	beforeDestroy() {
		document.querySelector("body").removeAttribute("style");
	},
};
</script>

<style scoped>
.body {
	background-color: #f2f2f2;
}
.mobileNews {
	padding-left: 0.426667rem;
	padding-right: 0.426667rem;
	margin-bottom: 0.426667rem;
}
.mobileRemind{
	border-radius: 0.106667rem 0.106667rem 0 0;

}
.mobileTrain{
	border-radius: 0 0 0.106667rem 0.106667rem;

}
.mobileNews .van-icon__image {
	width: 1.173333rem;
	height: 1.173333rem;
	margin-right: 0.32rem;
}
.van-cell__title{
    
color: #3C3C3C;
font-weight: bold;
font-size: .426667rem;
}
.van-cell__label{
    width: 4rem;
}
</style>


// WEBPACK FOOTER //
// MobileNews.vue?0c162d5a